import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ExportIcon from "../../components/Images/icons/Export_Icon_01.png";
import { toast } from "react-toastify";
import Response_Loading_processing from "../../layout/Others/Response_Loading_processing";
import { getItemToken } from "../../Utils/localStorageUtils";
import { donwloadCSV, videodownloadPDF, videodownloadXLSX } from "../../components/CommonMethod/CommonMethods";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { RxReload } from "react-icons/rx";
import { useMyContext } from "../../components/Provider/CommonProvider";

function Partner_Index_List() {
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [withOutRefresh, setWithoutRefresh] = useState(false);
  
  const { fetchRequest } = useMyContext();
  const BaseUrl = process.env.REACT_APP_Baseurl;
  const listApi = `${BaseUrl}/admin/partner-monitazation-index`;




  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await fetchRequest({
          method: "GET",
          url: listApi,
          data: {},
        });
        if (response?.status) {
          setApiData(response?.data || []);
          setFilteredData(response?.data || []);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error(error?.response?.data?.message || "Failed to fetch data");
        setLoading(false);
      }
    })();
  }, [withOutRefresh]);


  const handleFilterChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);

    const filteredResults = apiData.filter((item) => {
      return (
        (item?.partner_id?.toString()?.toLowerCase()?.includes(searchTerm)) ||
        (item?.user?.name?.toLowerCase()?.includes(searchTerm)) ||
        (item?.total_views?.toString()?.toLowerCase()?.includes(searchTerm)) ||
        (item?.total_payout?.toString()?.toLowerCase()?.includes(searchTerm)) ||
        (item?.partner_comission?.toString()?.toLowerCase()?.includes(searchTerm))
      );
    });
    setFilteredData(filteredResults);
  };

  const handleClear = () => {
    setFilter("");
    setFilteredData(apiData);
  };

  const reloadAction = () => {
    setWithoutRefresh(prev => !prev);
  };

  // Export Functions
  const fetchAllData = async (type, find) => {
    let updatedList = find === "ALL" ? apiData : filteredData;

    const exportData = updatedList.map((item, index) => ({
      "S.NO": index + 1,
      "ID": item?.partner_id,
      "CHANNEL NAME": item?.user?.name || 'N/A',
      "TOTAL VIEWS": item?.total_views,
      "TOTAL PAYOUT": item?.total_payout,
      "PAY COMMISSION": item?.partner_comission,
    }));

    if (type === "CSV") {
      await donwloadCSV(exportData, "PARTNER-MONETIZATION-INDEX");
    } else if (type === "PDF") {
      await videodownloadPDF(exportData, "PARTNER-MONETIZATION-INDEX", [
        "S.NO", "ID", "CHANNEL NAME", "TOTAL VIEWS", "TOTAL PAYOUT", "PAY COMMISSION"
      ]);
    } else if (type === "XLSX") {
      await videodownloadXLSX(exportData, "PARTNER-MONETIZATION-INDEX", [
        "S.NO", "ID", "CHANNEL NAME", "TOTAL VIEWS", "TOTAL PAYOUT", "PAY COMMISSION"
      ]);
    }
  };

  // Table Columns
  const columns = [
    {
      dataField: "rowNumber",
      text: "ID",
      sort: false,
      headerStyle: { width: '100px' },
      formatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      dataField: "user.name",
      text: "CHANNEL NAME",
      sort: true,
      formatter: (cell, row) => row?.user?.name || 'N/A'
    },
    {
      dataField: "total_views",
      text: "TOTAL VIEWS",
      sort: true,
    },
    {
      dataField: "total_payout",
      text: "TOTAL PAYOUT",
      sort: true,
      formatter: (cell) => cell ? `$${parseFloat(cell).toFixed(2)}` : '$0.00'
    },
    {
      dataField: "partner_comission",
      text: "PAY COMMISSION",
      sort: true,
      formatter: (cell) => cell ? `${parseFloat(cell).toFixed(1)}%` : '0%'
    },
  ];

  // Pagination Config
  const paginationConfig = paginationFactory({
    page: 1,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "All", value: filteredData?.length },
    ],
  });

  return (
    <>
      <section className="section container-fluid pt-3">
        <div className="row">
          <div className="col-sm-12">
            <div className="iq-card">
              <div className="iq-card-header d-flex justify-content-between">
                <div className="iq-header-title">
                  <h4 className="card-title">Partner Monetization Index</h4>
                </div>
              </div>
              <hr />

              <div className="iq-card-body">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
                  <div className="filterContainer">
                    <input
                      type="text"
                      placeholder="Filter all.."
                      className="filter form-control"
                      value={filter}
                      onChange={handleFilterChange}
                    />
                    {filter?.length > 0 && (
                      <button type="button" className="closeBtn" onClick={handleClear}>
                        <i className="fa fa-times"></i>
                      </button>
                    )}
                  </div>

                  <div className="btn-group flex-wrap justify-content-between justify-content-sm-end">
                    <button
                      className="bg-transparent reloadButton theme-text-color p-2 me-2 border border-2 rounded-circle theme-border-color"
                      onClick={reloadAction}
                    >
                      <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                    </button>

                    <div className="dropdown d-block mb-2 mb-sm-0 mx-0" key={"2"}>
                      <button
                        className="btn btn-success dropdown-toggle d-flex mx-0"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span className="fw-bolder">Export </span>
                        <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li className="dropdown-item" onClick={() => fetchAllData("CSV")}>
                          CSV
                        </li>
                        <li className="dropdown-item" onClick={() => fetchAllData("PDF")}>
                          PDF
                        </li>
                        <li className="dropdown-item" onClick={() => fetchAllData("XLSX")}>
                          XLSX
                        </li>
                      </ul>
                    </div>

                    <div className="dropdown d-block">
                      <button
                        className="btn btn-success dropdown-toggle d-flex"
                        type="button"
                        id="dropdownMenuButton2"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span className="fw-bolder">Export All</span>
                        <img src={ExportIcon} className="ms-2 exportIcon" alt="exportAllIcon" />
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                        <li className="dropdown-item" onClick={() => fetchAllData("CSV", "ALL")}>
                          CSV
                        </li>
                        <li className="dropdown-item" onClick={() => fetchAllData("PDF", "ALL")}>
                          PDF
                        </li>
                        <li className="dropdown-item" onClick={() => fetchAllData("XLSX", "ALL")}>
                          XLSX
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bootstrapTable">
                  <BootstrapTable
                    keyField="partner_id"
                    columns={columns}
                    data={filteredData}
                    pagination={paginationConfig}
                    className="no-border-table"
                    noDataIndication={
                      <div className="noRecord">
                        {loading ? (
                          <label>
                            <Response_Loading_processing />
                            Loading...
                          </label>
                        ) : (
                          filteredData?.length <= 0 && <p>No Data Found!</p>
                        )}
                      </div>
                    }
                    hover
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Partner_Index_List;
